import { render, staticRenderFns } from "./ContentsView.vue?vue&type=template&id=6c609ce7&scoped=true"
import script from "./ContentsView.vue?vue&type=script&lang=js"
export * from "./ContentsView.vue?vue&type=script&lang=js"
import style0 from "./ContentsView.vue?vue&type=style&index=0&id=6c609ce7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c609ce7",
  null
  
)

export default component.exports